import { IAppState } from '../../../../../../common/context/context'
import {
  selectSearchNeumaticos,
  selectSearchNeumaticosQueryState,
} from '../../../searchNeumaticos.store'
import { createSelector } from '@reduxjs/toolkit'

export const selectMedidas = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas

export const selectIsMedidasConfirmed = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.isMedidasConfirmed

export const selectMedidasData = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.medidasData

export const selectSelectedMedidas = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.selectedMedidas

export const selectPreviousSelectedMedidas = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.previousSelectedMedidas

export const selectSelectedEstacion = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.selectedEstacion

export const selectEstacionSeleccionadaPorUsuario = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.estacionSeleccionadaPorUsuario

export const selectMarcaFilterOptOut = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.marcaFilterOptOut

export const selectMatriculaMedidas = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.matriculaMedidas

export const selectMatriculaMedidasLoading = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.matriculaMedidasLoading

export const selectMatriculaMedidasError = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.matriculaMedidasError

export const selectPendingAutoFocusNextMedida = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.pendingAutoFocusNextMedida

export const selectDeferMedidasCatalogConfirmUntilApply = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.deferMedidasCatalogConfirmUntilApply

export const selectMedidasAlteredOnCatalog = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.medidasAlteredOnCatalog

export const selectSelectedMatriculaMeasureId = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.selectedMatriculaMeasureId

export const selectVehicleTyreSelectionWasPartial = (state: IAppState) =>
  selectSearchNeumaticos(state).medidas.vehicleTyreSelectionWasPartial

export const selectSelectedMedidasSubtitle = createSelector(
  [selectSelectedMedidas, selectPreviousSelectedMedidas, selectIsMedidasConfirmed],
  (selected, previous, isConfirmed) => {
    const m = isConfirmed ? selected : previous
    const { ancho, serie, llanta, carga, velocidad } = m ?? {}

    if (
      ancho == null ||
      serie == null ||
      llanta == null ||
      carga == null ||
      velocidad == null
    ) {
      return ''
    }

    return `${ancho}/${serie} R${llanta} ${carga}${velocidad}`
  }
)

export const selectHasAllMedidas = (state: IAppState) => {
  const m = selectSearchNeumaticosQueryState(state).medidas.selectedMedidas
  const pm = selectSearchNeumaticosQueryState(state).medidas.pageMedida

  if (pm) return (
    m.ancho != null &&
    m.serie != null &&
    m.llanta != null
  )

  return (
    m.ancho != null &&
    m.serie != null &&
    m.llanta != null &&
    m.carga != null &&
    m.velocidad != null
  )
}
